import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TooltipTarget from '../tooltip/TooltipTarget';

class VxRadioField extends Component {
	static propTypes = {
		input: PropTypes.object,
		label: PropTypes.string,
		meta: PropTypes.object,
		id: PropTypes.string,
		checkedValue: PropTypes.string,
		tooltipContent: PropTypes.string,
		tooltipId: PropTypes.string,
		tooltipPlacement: PropTypes.string
	};

	render() {
		const {
			input,
			label,
			meta: { touched, error },
			id
		} = this.props;

		const hasError = touched && error;

		return (
			<div className="vx_text-body">
				<div className={`vx_radio ${hasError ? 'vx_has-error' : ''}`}>
					<input
						{...input}
						type="radio"
						id={id}
						checked={this.props.checkedValue === input.value}
					/>
					<label htmlFor={id}>{label}
						{this.props.tooltipContent &&
							<TooltipTarget content={this.props.tooltipContent}
								id={this.props.tooltipId}
								placement={this.props.tooltipPlacement}>
							</TooltipTarget>
						}
					</label>
				</div>
			</div>
		);
	}
}
export default VxRadioField;



// WEBPACK FOOTER //
// ./buttons/components/vxFields/VxRadioField.js